/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_None_LeadInputs */

const en_us2_draft_none_lead = /** @type {(inputs: Draft_None_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When there is a new plan to propose, it shows up here.`)
};

const pt_br2_draft_none_lead = /** @type {(inputs: Draft_None_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando houver uma proposta de plano novo, ela aparece aqui.`)
};

const es_419_draft_none_lead = /** @type {(inputs: Draft_None_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuando haya un plan nuevo para proponer, aparecerá aquí.`)
};

const pt_pt2_draft_none_lead = /** @type {(inputs: Draft_None_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando houver uma proposta de plano novo, aparece aqui.`)
};

const fr_fr2_draft_none_lead = /** @type {(inputs: Draft_None_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quand un nouveau programme sera proposé, il apparaîtra ici.`)
};

const de_de2_draft_none_lead = /** @type {(inputs: Draft_None_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn es einen neuen Planvorschlag gibt, erscheint er hier.`)
};

const it_it2_draft_none_lead = /** @type {(inputs: Draft_None_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando ci sarà una nuova scheda da proporre, comparirà qui.`)
};

/**
* | output |
* | --- |
* | "When there is a new plan to propose, it shows up here." |
*
* @param {Draft_None_LeadInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_none_lead = /** @type {((inputs?: Draft_None_LeadInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_None_LeadInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_none_lead(inputs)
	if (locale === "es-419") return es_419_draft_none_lead(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_none_lead(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_none_lead(inputs)
	if (locale === "de-DE") return de_de2_draft_none_lead(inputs)
	if (locale === "it-IT") return it_it2_draft_none_lead(inputs)
	return en_us2_draft_none_lead(inputs)
});
export { draft_none_lead as "draft.none_lead" }